import React from 'react';
import MasterclassIndex from './health';

export default function () {
  return (
    <MasterclassIndex
      entry="curious"
      pageTitle="What’s the Deal with Everyone Going Plant-based?"
      pageDescription="Watch the Mini-Masterclass — airing now for free"
      ogImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-veg-curious-1200x1200-v20221103.jpg"
      shareUrl="https://plantplaybook.foodrevolution.org/masterclass/plantbased/"
      facebookDescription="Here are the top 3 reasons everyone from doctors to athletes to popstars are going plant-based — and why you might want to join them if you haven’t already."
      twitterDescription="Here are the top 3 reasons everyone from doctors to athletes to popstars are going plant-based — and why you might want to join them if you haven’t already."
      twitterImg="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-veg-curious-1200x630-20221103.jpg"
      pinterestDescription="Here are the top 3 reasons everyone from doctors to athletes to popstars are going plant-based — and why you might want to join them if you haven’t already."
      pinterestImg="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-veg-curious-1000x1500-20221103.jpg"
    />
  );
}
